export const ROID_OT_SELECTED_GENERAL_VIEW = 'ROID_OT_SELECTED_GENERAL_VIEW';
export const ROID_OT_SELECTED_GENERAL_VIEW_RESET =
  'ROID_OT_SELECTED_GENERAL_VIEW_RESET';

// Navigation metadata for breadcrumb context (used as Redux backup for sessionStorage)
export interface NavigationMetadata {
  origin?: 'workorder' | 'table';
  parentOrderId?: string;
  parentRoid?: string;
  entityRoid?: string;
}

export function roidOTSelected(
  type: string,
  roid: string,
  id: string,
  capitol?: string,
  subCapitol?: string,
  metadata?: NavigationMetadata
) {
  return {
    type: ROID_OT_SELECTED_GENERAL_VIEW,
    payload: {
      type,
      roid,
      id,
      capitol: capitol || '',
      subCapitol: subCapitol || '',
      // Navigation metadata for breadcrumb context
      origin: metadata?.origin || null,
      parentOrderId: metadata?.parentOrderId || null,
      parentRoid: metadata?.parentRoid || null,
      entityRoid: metadata?.entityRoid || null,
    },
  };
}

export function roidOTSelectedReset() {
  return {
    type: ROID_OT_SELECTED_GENERAL_VIEW_RESET,
  };
}
